import type { PortfolioCommandData } from '@festina/unitlink-general-types/unitlink'

import { EditPortfolioCommand } from '../../actions/editPortfolio/EditPortfolioCommand'
import { InvestmentSpecCommand } from '../../actions/investmentSpec/InvestmentSpecCommand'
import { InvestmentSpecCommandV2 } from '../../actions/investmentSpec/InvestmentSpecCommandV2'
import { PortfolioCorrectionCommand } from '../../actions/portfolioCorrection/PortfolioCorrectionCommand'
import { SwitchSubPortfolioCommand } from '../../actions/switchSubPortfolioCommand/SwitchSubPortfolioCommand'
import { SwitchSubPortfolioGroupCommand } from '../../actions/SwitchSubPortfolioGroupCommand/SwitchSubPortfolioGroupCommand'
import { SwitchTradeCommand } from '../../actions/switchTrade/SwitchTradeCommand'
import { PortfolioCommandModalButtonFallback } from '../PortfolioCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'

export const portfolioCommands: CommandDataRecord<
  PortfolioCommandData['_type']
> = {
  AddPortfolioBalancePostingsCommandData: PortfolioCommandModalButtonFallback,
  AutoEmptyMoveCommandData: PortfolioCommandModalButtonFallback,
  HandleOpenPostCommandData: PortfolioCommandModalButtonFallback,
  CloseSubPortfolioCommandData: PortfolioCommandModalButtonFallback,
  MoveSubPortfolioCommandData: PortfolioCommandModalButtonFallback,
  RevertCloseSubPortfolioCommandData: PortfolioCommandModalButtonFallback,
  InvestmentSpecCommandData: InvestmentSpecCommand,
  InvestmentSpecCommandDataV2: InvestmentSpecCommandV2,
  InvestmentTradeCommandData: PortfolioCommandModalButtonFallback,
  NewSubPortfoliosCommandData: PortfolioCommandModalButtonFallback,
  NewSubPortfoliosCommandDataV2: PortfolioCommandModalButtonFallback,
  RebalanceCommandData: PortfolioCommandModalButtonFallback,
  SetPortfolioOwnerCommandData: PortfolioCommandModalButtonFallback,
  SwitchTradeCommandData: SwitchTradeCommand,
  TradeExecutionCommandData: PortfolioCommandModalButtonFallback,
  UnitlinkConversionCommandData: PortfolioCommandModalButtonFallback,
  UnitlinkMigrationCommandData: PortfolioCommandModalButtonFallback,
  PortfolioCorrectionCommandData: PortfolioCorrectionCommand,
  RevertMoveSubPortfolioCommandData: PortfolioCommandModalButtonFallback,
  RevertNewSubPortfoliosCommandData: PortfolioCommandModalButtonFallback,
  EndEmploymentCommandData: PortfolioCommandModalButtonFallback,
  RevertEndEmploymentCommandData: PortfolioCommandModalButtonFallback,
  SwitchSubPortfolioCommandData: SwitchSubPortfolioCommand,
  SwitchSubPortfolioGroupCommandData: SwitchSubPortfolioGroupCommand,
  EditPortfolioCommandData: EditPortfolioCommand,
  RevertStartEmploymentCommandData: PortfolioCommandModalButtonFallback,
  StartEmploymentCommandData: PortfolioCommandModalButtonFallback,
}
